/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlatbedTowing32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M19.88 4.53a1.87 1.87 0 00-1.87 1.87v.53h-2.496v15.36h-8.4a2.99 2.99 0 001.48-1.875l5.636-.008v-3.175a4.413 4.413 0 00-3.485-4.313l-4.864-1.046-.66-.942-1.523-2.175A3.352 3.352 0 00.954 7.328H0v1.5h.954c.603 0 1.17.295 1.515.789l1.524 2.175.003.004H0v1.5h5.365l5.065 1.09a2.91 2.91 0 012.006 1.572h-.135c-.387 0-.771-.079-1.13-.232l-.412-.176-.183-.079-.594 1.378.186.08.416.177a4.377 4.377 0 001.717.352h.429v1.451l-4.132.006a2.985 2.985 0 00-5.783.009L0 18.928v1.5l2.823-.004A2.99 2.99 0 004.3 22.29H.04v1.5h15.474v1.918H.04v1.5h19.2a4.272 4.272 0 008.32 0h4.134v-7.15c0-.799-.435-1.536-1.138-1.92l-2.446-1.34-1.15-.63-1.749-9.238H21.75V6.4a1.868 1.868 0 00-1.87-1.87zm-2.866 12.374v8.804h2.149a4.27 4.27 0 018.474 0h2.557v-5.65a.686.686 0 00-.357-.604l-2.448-1.34-1.77-.97-1.65-8.714h-6.955v6.974h5.315v-2.208h1.5v4.494h-1.5v-.786h-5.315zM19.51 6.4v.53h.74V6.4a.368.368 0 00-.37-.37.37.37 0 00-.37.37zm3.89 17.07a2.77 2.77 0 100 5.54 2.77 2.77 0 000-5.54zM5.708 21.155a1.497 1.497 0 100-2.993 1.497 1.497 0 000 2.993z'
      />
    </svg>
  );
}

export default SvgFlatbedTowing32;
